/* import __COLOCATED_TEMPLATE__ from './seller-profile-block-freelancer.hbs'; */
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';
import { showModal } from "sh-www/utils/modal-controls";
import { BLOCK_FREELANCER_ELEMENT_ID } from "../../constants/components/profile";

export default Component.extend({
  /**
   * HTML Component properties
   */
  tagName: 'section',
  classNames: ['SH-c-seller-profile-block-freelancer'],
  classNameBindings: ['_hasBlockUserEvents::hide'],

  /** @param {User} user */
  user: null,

  /**
   * @type {String}   Element id of the main freelancer element
   */
  _blockFreelancerElementId: BLOCK_FREELANCER_ELEMENT_ID,

  /**
   * @type {Boolean}  True if we have any block user events
   */
  _hasBlockUserEvents: readOnly('user.blockUserEventsSorted.length'),

  /** Shows the block freelancer modal */
  _showBlockFreelancerModal() {
    showModal(this, 'block-freelancer-modal', {
      freelancerProfile: this.get('user'),
    });
  },

  actions: {
    /**
     * When block user is clicked
     */
    onBlockClicked: function() {
      this._showBlockFreelancerModal();
    },

    /**
     * When unblock user is clicked
     */
    onUnblockClicked: function() {
      this._showBlockFreelancerModal();
    }
  }
});
